export default __webpack_public_path__ + "static/media/conjure-logo.868c3757.png";